<template>
  <section class="units-wrap py-5">
    <div class="container">

      <!-- Titre -->
      <p class="units-intro text-center mb-5">
        Formations par unités – Une flexibilité adaptée à votre emploi du temps
      </p>

      <!-- Informations générales -->
      <div class="info-box mb-5">
        <p>
          Certaines personnes peuvent suivre une formation <strong>par unité</strong>,
          pour raison d’indisponibilité ou attentes particulières, assortie d’un certificat.
        </p>
        <p>
          Chaque unité coûte <strong>40.000 FCFA</strong> + <strong>3.000 FCFA</strong> de frais
          d’inscription et de photocopie. Les frais sont payables avant le début de chaque unité
          et sont <strong>non remboursables</strong>.
        </p>
        <p>
          À tout moment, un participant peut revenir dans la formation normale. Les cours
          non suivis et les activités non exécutées seront alors complétés.
        </p>
      </div>

      <!-- Parcours -->
      <div v-for="(parcours, i) in parcoursList" :key="i" class="mb-5">
        <h4 class="section-subtitle mb-3 text-center">{{ parcours.title }}</h4>

        <div v-for="(year, yIndex) in parcours.years" :key="yIndex" class="mb-4">
          <h5 class="year-title mb-2">{{ year.title }}</h5>

          <div v-for="(unit, uIndex) in year.units" :key="uIndex" class="section-box mb-3">
            <h6 class="unit-title mb-2">{{ unit.name }}</h6>
            <p class="unit-note fst-italic mb-2">{{ unit.quote }}</p>

            <ul>
              <li v-for="(module, mIndex) in unit.modules" :key="mIndex">
                <strong>{{ module.title }}</strong> : {{ module.content }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <h4 class="section-subtitle mb-3 text-center">Parcours OMEGA – Première Année</h4>

    <!-- UNITÉ 1 -->
    <div class="section-box mb-3">
      <h6 class="unit-title mb-2">Unité 1 –Connaître sa foi pour mieux se connaître</h6>
      <h5 class="unit-title mb-2">Bible : Parole de Dieu ou paroles d’homme ?</h5>
      <p>
        Découvrir la Bible, en quoi elle est à la fois œuvre de Dieu et des hommes,
        et son importance pour le chrétien, disciple de la Parole
        (étude d’un texte biblique).
      </p>

      <h5 class="unit-title mb-2">Introduction à la Théologie</h5>
      <p>
        Indiquer comment la foi s’intègre à toutes les dimensions de la vie
        et lui donne sens (définition, rapport à la raison et à la culture).
      </p>

      <h5 class="unit-title mb-2">Être jeune et leader</h5>
    </div>

    <!-- UNITÉ 2 -->
    <div class="section-box mb-3">
      <h6 class="unit-title mb-2">Unité 2 –Découvrir le monde et ses lois selon Dieu</h6>

      <h5 class="unit-title mb-2">Et Dieu créa le ciel et la terre</h5>
      <p>
        Souligner la spécificité des récits bibliques de création et leur rapport
        aux découvertes scientifiques (compatibilité) et fonder un environnement.
      </p>

      <h5 class="unit-title mb-2">La grâce d’être jeune : Amitié et Amour</h5>
      <p>
        Se connaître comme jeune, découvrir sa valeur en évitant les pièges
        relatifs à cet âge (à partir des Écritures et de la vie).
      </p>

      <h5 class="unit-title mb-2">Liturgie : Grands repères liturgiques</h5>
      <p>
        Comprendre la liturgie à travers ses rites et son organisation
        (couleurs, temps liturgiques, calendrier liturgique)
        comme un acte de foi.
      </p>

      <h5 class="unit-title mb-2">Méthodologie de travail et de recherche</h5>
      <p>
        Savoir formuler, poser et analyser un problème,
        au regard des défis africains.
      </p>
    </div>

    <!-- UNITÉ 3 -->
    <div class="section-box mb-3">
      <h6 class="unit-title mb-2">Unité 3 –Connaître Dieu pour mieux le prier</h6>

      <h5 class="unit-title mb-2">Les Psaumes : paroles magiques ou paroles de foi ?</h5>
      <ul>
        <li>Qu’est-ce que les psaumes ?</li>
        <li>Existe-t-il une clé des psaumes ?</li>
        <li>La relecture chrétienne des psaumes</li>
      </ul>

      <h6 class="unit-title mb-2">Le Mystère de Dieu</h6>
      <p>
        Découvrir la présence de Dieu dans le monde et dans sa Parole
        et avoir les outils pour affronter les pathologies
        de la religion et de la raison.
      </p>

      <h5 class="unit-title mb-2">Spiritualité</h5>
      <p>
        Apprendre à prier comme chrétien
        à partir de la Parole de Dieu (Lectio Divina).
      </p>

      <h5 class="unit-title mb-2">L’Église en fondation et l’Église définit sa foi</h5>
      <p>
        Connaître l’histoire de l’Église
        (Siècles I – III et IV – IX).
      </p>
    </div>

    <!-- UNITÉ 4 -->
    <div class="section-box mb-3">
      <h6 class="unit-title mb-2">Unité 4 –Devenir témoin et influenceur de Dieu dans le monde</h6>

      <h5 class="unit-title mb-2">Introduction aux Prophètes</h5>
      <ul>
        <li>Qui est le prophète ? Pourquoi être prophète ?</li>
        <li>Les grands thèmes des prophètes</li>
        <li>Comment être prophète aujourd’hui ? Étude d’un prophète jeune</li>
      </ul>

      <h5 class="unit-title mb-2">Le mystère de Dieu Un et Trine</h5>
      <p>
        Découvrir le mystère de la Trinité
        et ses implications pour la vie de foi.
      </p>

      <h5 class="unit-title mb-2">Analyse des racines culturelles et historiques de la crise africaine</h5>
      <p>
        Des outils pour comprendre les défis africains
        (culture, esclavage, colonisation).
      </p>

      <h5 class="unit-title mb-2">Morale</h5>
      <ul>
        <li>Principes de la morale chrétienne</li>
        <li>
          Principes fondamentaux de la Doctrine Sociale de l’Église :
          conscience, vérité, justice
        </li>
      </ul>
    </div>

     <h4 class="section-subtitle mb-3 text-center">Parcours OMEGA – Deuxième Année</h4>

    <!-- UNITÉ 5 -->
    <div class="section-box mb-3">
      <h6 class="unit-title mb-2">Unité 5 – Vivre du Christ, le Témoin de Dieu</h6>

      <h5 class="unit-title mb-2">Les Évangiles</h5>
      <ul>
        <li>Comment les Évangiles ont-ils été rédigés ?</li>
        <li>Toutes les paroles de l’Évangile ont-elles été dites par le Christ ?</li>
        <li>Y a-t-il des évangiles cachés ?</li>
      </ul>

      <h5  class="unit-title mb-2">Le mystère de Jésus, vrai Dieu et vrai homme</h5>
      <ul>
        <li>Jésus a-t-il vraiment existé ?</li>
        <li>Jésus est-il vraiment Dieu ?</li>
        <li>Comment peut-on être Dieu et homme ?</li>
        <li>Jésus n’est-Il pas un prophète comme Mahomet ou Bouddha ?</li>
      </ul>

      <h5 class="unit-title mb-2">Le chrétien dans la cité</h5>
      <p>
        La foi chrétienne détourne-t-elle des enjeux terrestres ?
        <br />
        L’engagement chrétien.
      </p>

      <h5 class="unit-title mb-2">Méthodologie de travail et de recherche</h5>
      <p>
        Travailler avec méthode, c’est réussir ses études et sa vie.
      </p>
    </div>

    <!-- UNITÉ 6 -->
    <div class="section-box mb-3">
      <h6 class="unit-title mb-2">Unité 6 – Parler et vivre en chrétien authentique</h6>

      <h5  class="unit-title mb-2">Les Actes et l’œuvre de l’Apôtre Paul</h5>
      <ul>
        <li>Comment vivaient les premiers chrétiens ?</li>
        <li>Paul est-il le fondateur du Christianisme ?</li>
      </ul>

      <h5 class="unit-title mb-2">L’Esprit-Saint, l’Église et Marie</h5>
      <ul>
        <li>Jésus a-t-Il jamais fondé une Église ?</li>
        <li>Avons-nous encore besoin du Saint-Esprit ?</li>
        <li>Marie a-t-elle eu d’autres enfants après Jésus ?</li>
      </ul>

      <h5 class="unit-title mb-2">Prendre la parole en public</h5>
      <p>
        Comment défendre son point de vue et convaincre efficacement ?
        <br />
        Parler en public s’apprend.
      </p>

      <h5 class="unit-title mb-2">Spiritualité</h5>
      <p>
        Étude de la vie d’un saint :
        <br />
        Martyrs de l’Ouganda, Saint Carlo Acutis, Sainte Thérèse de Lisieux.
      </p>
      <ul>
        <li>Un jeune peut-il devenir saint ?</li>
        <li>Comment être jeune aujourd’hui et devenir saint ?</li>
        <li>Peut-on avoir des saints africains aujourd’hui ?</li>
      </ul>
    </div>

    <!-- UNITÉ 7 -->
    <div class="section-box mb-3">
      <h6 class="unit-title mb-2">Unité 7 – Chercher le vrai bonheur</h6>

      <h5  class="unit-title mb-2">L’Apocalypse ou la victoire définitive du Christ sur le Mal</h5>
      <ul>
        <li>Dieu a-t-il déjà prévu le nombre des sauvés ?</li>
        <li>La fin du monde est-elle pour bientôt ?</li>
        <li>À la fin des temps, seuls les chrétiens seront-ils sauvés ?</li>
      </ul>

      <h5  class="unit-title mb-2">Les fins dernières et le temps présent</h5>
      <ul>
        <li>Le Purgatoire n’est-il pas une invention ? </li>
        <li>Le monde aura-t-il vraiment une fin et en quoi consistera-t-elle ? </li>
        <li>Sur quoi Dieu va-t-il nous juger ?</li>
        <li>Si Dieu est amour, pourquoi l’enfer ?</li>
      </ul>

      <h5 class="unit-title mb-2">Morale : Avortement et contraceptifs</h5>
      <ul>
        <li>Pour limiter la pauvreté en Afrique, la contraception n’est-elle pas un moyen très efficace ? </li>
        <li>Si l’Etat autorise l’avortement, en quoi l’Eglise peut-elle le refuser ? </li>
      </ul>

      <h5 class="unit-title mb-2">Plaidoyer ou les idéologies politiques</h5>
      <p>
        Comment défendre son point de vue et convaincre efficacement ?
        Parler en public n’est pas donné : on l’apprend

      </p>
    </div>

    <!-- UNITÉ 8 -->
    <div class="section-box mb-3">
      <h5 class="unit-title mb-2">Unité 8 – Repérer les chemins du bonheur</h5>

      <h5  class="unit-title mb-2">Grâce et Eucharistie</h5>
      <ul>
        <li>
          En s’appuyant sur sa bonne volonté, l’homme ne peut-il pas devenir meilleur et changer le monde ? 
        </li>
        <li>
          Faire de l’Eucharistie le corps et le sang de Jésus n’est-ce pas de l’idolâtrie ?  
        </li>
      </ul>

      <!-- <h5  class="unit-title mb-2">L’Église se réforme</h5>
      <p>Siècles X – XVIII</p> -->

      <h5 class="unit-title mb-2">L’Eglise se réforme (Siècles X-XVIII)-L’Eglise en mission (Siècles XIX – à nos jours)
</h5>
      <p>
        Comment sont apparus les Protestants et les Anglicans ?.
      </p>

      <h5 class="unit-title mb-2" >Grandes tendances : l’incompatibilité des cercles ésotériques avec le bonheur de l’homme</h5>
      <ul>
        <li>Peut-on avoir de l’argent à tout prix ? </li>
        <li>
          Pour mon bonheur, est-ce que je peux rentrer dans la franc-maçonnerie ?
        </li>
      </ul>
    </div>

    </div>

    
  </section>
</template>

<script lang="ts">
export default {
  name: "FormationsParUnites",
  data() {
    return {
      parcoursList: [
        {
          title: "Parcours Emmaüs 1 – Première année",
          years: [
            {
              title: "Année 1",
              units: [
                {
                  name: "Unité 1 – Connaître sa foi pour être témoin de Dieu",
                  quote: "« Homme de peu de foi » Mt 14,31 – « Ta foi t’a sauvé » Mc 10,52",
                  modules: [
                    { title: "Bible", content: "Parole de Dieu ou paroles d’homme" },
                    { title: "Introduction à la Théologie", content: "Bases de la foi chrétienne" },
                    { title: "Initiation au latin", content: "Alphabet et expressions de base" },
                    { title: "Méthodologie", content: "Résumé d’article / Prise de parole 1" },
                    { title: "Foi et Raison", content: "Culture / Histoire de l’Église et Mémoire" },
                    { title: "Vie des saints", content: "La sainteté comme programme pour l’Église en Afrique" }
                  ]
                },
                {
                  name: "Unité 2 – Découvrir la présence de Dieu dans le monde et dans son histoire",
                  quote: "« Où aller, loin de ton souffle ? Où m'enfuir, loin de ta face ?» Ps 139,7 – « Tu me scrutes, Seigneur, et tu sais ! » Ps 138,1",
                  modules: [
                    { title: "Révélation de Dieu", content: "Dans la création et l’histoire de son peuple" },
                    { title: "La Création", content: "Fondements bibliques et scientifiques" },
                    { title: "Histoire de l’Église", content: "Fondation et réforme" },
                    { title: "Introduction à la liturgie", content: "Année liturgique" },
                    { title: "Peuple de Dieu", content: "Peines et défis dans l’Église" },
                    { title: "Méthodologie", content: "Résumé de livre / Prise de parole 2" }
                  ]
                },
                {
                  name: "Unité 3 – Rencontrer Dieu pour mieux Le prier",
                  quote: "« Jésus appela ceux qu’il voulait (…) pour qu’ils soient avec lui » Mc 3,13-14 – « Veillez et priez » Mt 26,41",
                  modules: [
                    { title: "Les Psaumes", content: "Paroles magiques ou paroles de foi" },
                    { title: "L’existence de Dieu", content: "Fondements et démonstrations" },
                    { title: "Principes de la morale chrétienne", content: "Veritatis Splendor" },
                    { title: "Principes généraux de la spiritualité chrétienne", content: "" },
                    { title: "Lectio Divina", content: "Lecture priante et méditative de la Bible" },
                    { title: "Histoire de l’Église", content: "Fondation et mission" },
                    { title: "Directoire sur la piété populaire et la liturgie", content: "Étude de Iuvenescit Ecclesia" },
                    { title: "Méthodologie", content: "Présentation de thème / Plaidoyer" }
                  ]
                },
                {
                  name: "Unité 4 – Devenir témoin de Dieu",
                  quote: "« Vous serez mes témoins jusqu’aux extrémités de la terre » Ac 1,8",
                  modules: [
                    { title: "Introduction aux prophètes", content: "Rôle et mission du prophète aujourd’hui" },
                    { title: "Le mystère de Dieu Un et Trine", content: "Implications pour la vie de foi" },
                    { title: "Doctrine sociale / Le chrétien dans la cité", content: "" },
                    { title: "Biens temporels / Droit matrimonial", content: "" },
                    { title: "Transmission et communication de la foi / Dominus Iesus", content: "" },
                    { title: "Importance de la Philosophie pour la Théologie et nos Cultures", content: "Les grandes tendances contemporaines" }
                  ]
                }
              ]
            }
          ]
        },
        {
          title: "Parcours Emmaüs 2 – Deuxième année",
          years: [
            {
              title: "Année 2",
              units: [
                {
                  name: "Unité 1 – Chercher le vrai bonheur",
                  quote: "« Recherchez les réalités d’en haut » Col 3,1",
                  modules: [
                    { title: "Apocalypse", content: "" },
                    { title: "Fins dernières et temps présent", content: "" },
                    { title: "Sacrements et Sacramentaux", content: "Fondements théologiques" },
                    { title: "Questions bioéthiques", content: "" },
                    { title: "Vie des saints", content: "La sainteté comme programme pour l’Église en Afrique" },
                    { title: "Foi et Raison", content: "Culture / Histoire de l’Église et Mémoire" },
                    { title: "Méthodologie", content: "Résumé d’article / Prise de parole 1" }
                  ]
                },
                // Tu peux continuer de la même façon pour les autres unités...
              ]
            }
          ]
        },
    
      ]
    }
  }
}
</script>

<style scoped>
.units-wrap {
  background: #f8f9fa;
}
.units-intro {
  color: #6c757d;
}
.section-subtitle, .year-title {
  color: #0b1b3f;
  font-weight: 700;
}
.unit-title {
  font-weight: 600;
  color: #0b1b3f;
}
.section-box {
  background: white;
  padding: 25px;
  border-radius: 16px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
}
.info-box {
  background: white;
  padding: 22px;
  border-radius: 14px;
  border-left: 6px solid #0b1b3f;
}
.unit-note {
  color: #6c757d;
  font-style: italic;
}
ul li {
  margin-bottom: 8px;
  line-height: 1.5;
}

.parcours-omega {
  padding: 2rem;
}

.title {
  text-align: center;
  margin-bottom: 2rem;
}

.unite {
  margin-bottom: 2.5rem;
  padding: 1.5rem;
  border: 1px solid #ddd;
  border-radius: 8px;
}

h3 {
  color: #2c3e50;
  margin-bottom: 1rem;
}

h4 {
  margin-top: 1rem;
  font-weight: 600;
}

ul {
  padding-left: 1.2rem;
}
</style>
